import React from 'react';
const PrivacyPolicy = () => {
  return <div className="min-h-screen bg-white" data-id="element-452">
      <div className="bg-mwc-burgundy text-white py-12" data-id="element-453">
        <div className="container mx-auto px-4" data-id="element-454">
          <h1 className="text-3xl font-bold text-center mb-4" data-id="element-455">
            Privacy & Cookie Notice
          </h1>
          <p className="text-lg text-center max-w-3xl mx-auto" data-id="element-456">
            How we collect, use, and protect your personal information
          </p>
        </div>
      </div>
      <div className="container mx-auto px-4 py-12" data-id="element-457">
        <div className="max-w-3xl mx-auto" data-id="element-458">
          <div className="bg-white rounded-lg shadow-md p-8" data-id="element-459">
            <div className="mb-8" data-id="element-460">
              <p className="text-gray-700" data-id="element-461">
                Maplewood-Care ("we", "our", "us") is committed to protecting
                and respecting your privacy. This Privacy & Cookie Notice
                explains how we collect, use, and protect your personal
                information.
              </p>
            </div>
            <div className="mb-8" data-id="element-462">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-463">
                Information We Collect
              </h2>
              <div className="bg-mwc-lightpink p-4 rounded-lg mb-4" data-id="element-464">
                <p className="text-gray-700 mb-2" data-id="element-465">
                  We may collect the following information:
                </p>
                <ul className="list-disc pl-6 text-gray-700" data-id="element-466">
                  <li data-id="element-467">Name, contact details, and address</li>
                  <li data-id="element-468">Appliance details (make, model, age, etc.)</li>
                  <li data-id="element-469">Service history and preferences</li>
                  <li data-id="element-470">Payment information</li>
                  <li data-id="element-471">Communications with our team</li>
                </ul>
              </div>
            </div>
            <div className="mb-8" data-id="element-472">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-473">
                How We Use Your Information
              </h2>
              <div className="bg-mwc-lightpink p-4 rounded-lg mb-4" data-id="element-474">
                <p className="text-gray-700 mb-2" data-id="element-475">
                  We use your information to:
                </p>
                <ul className="list-disc pl-6 text-gray-700" data-id="element-476">
                  <li data-id="element-477">Provide and manage the services you've requested</li>
                  <li data-id="element-478">Process payments and maintain accounts</li>
                  <li data-id="element-479">
                    Communicate with you about your service plan or repairs
                  </li>
                  <li data-id="element-480">Improve our services and develop new offerings</li>
                  <li data-id="element-481">Comply with legal and regulatory obligations</li>
                </ul>
              </div>
            </div>
            <div className="mb-8" data-id="element-482">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-483">
                Information Sharing
              </h2>
              <div className="bg-mwc-lightpink p-4 rounded-lg mb-4" data-id="element-484">
                <p className="text-gray-700 mb-2" data-id="element-485">
                  We may share your information with:
                </p>
                <ul className="list-disc pl-6 text-gray-700" data-id="element-486">
                  <li data-id="element-487">
                    Our engineers and service providers who help deliver our
                    services
                  </li>
                  <li data-id="element-488">Payment processors to handle transactions</li>
                  <li data-id="element-489">Regulatory authorities when required by law</li>
                </ul>
                <p className="text-gray-700 mt-4" data-id="element-490">
                  We will never sell your personal data to third parties for
                  marketing purposes.
                </p>
              </div>
            </div>
            <div className="mb-8" data-id="element-491">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-492">
                Cookie Notice
              </h2>
              <div className="bg-mwc-lightpink p-4 rounded-lg mb-4" data-id="element-493">
                <p className="text-gray-700 mb-4" data-id="element-494">
                  Our website uses cookies to enhance your browsing experience
                  and analyze site traffic. Cookies are small text files stored
                  on your device that help the site provide a better user
                  experience.
                </p>
                <p className="text-gray-700 mb-2" data-id="element-495">
                  We use the following types of cookies:
                </p>
                <ul className="list-disc pl-6 text-gray-700" data-id="element-496">
                  <li data-id="element-497">
                    Essential cookies: Required for the website to function
                    properly
                  </li>
                  <li data-id="element-498">
                    Analytical/performance cookies: Help us improve our website
                    by collecting anonymous information
                  </li>
                  <li data-id="element-499">
                    Functionality cookies: Remember your preferences to enhance
                    your experience
                  </li>
                </ul>
                <p className="text-gray-700 mt-4" data-id="element-500">
                  You can control cookies through your browser settings.
                  Disabling cookies may affect the functionality of our website.
                </p>
              </div>
            </div>
            <div className="mb-8" data-id="element-501">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-502">
                Your Rights
              </h2>
              <div className="bg-mwc-lightpink p-4 rounded-lg mb-4" data-id="element-503">
                <p className="text-gray-700 mb-2" data-id="element-504">
                  Under UK data protection law, you have rights including:
                </p>
                <ul className="list-disc pl-6 text-gray-700" data-id="element-505">
                  <li data-id="element-506">The right to access your personal data</li>
                  <li data-id="element-507">The right to correction of inaccurate data</li>
                  <li data-id="element-508">The right to erasure (in certain circumstances)</li>
                  <li data-id="element-509">The right to restrict processing</li>
                  <li data-id="element-510">The right to data portability</li>
                </ul>
              </div>
            </div>
            <div data-id="element-511">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-512">
                Contact Us
              </h2>
              <div className="bg-mwc-lightpink p-4 rounded-lg" data-id="element-513">
                <p className="text-gray-700 mb-4" data-id="element-514">
                  If you have any questions about this Privacy & Cookie Notice
                  or wish to exercise your rights, please contact us at:
                </p>
                <ul className="list-disc pl-6 text-gray-700" data-id="element-515">
                  <li data-id="element-516">Email: support@maplewood-care.com</li>
                  <li data-id="element-517">
                    Post: Data Protection Officer, Maplewood-Care, 2B Westbury
                    Ave, London, N22 6BS
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default PrivacyPolicy;